
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analytics/services",
      function () {
        return require("private-next-pages/analytics/services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/analytics/services"])
      });
    }
  